import React, { Component } from 'react'
import ReactTooltip from 'react-tooltip'

export default class SEVS extends Component {
  render() {
      const {onClick} = this.props;
    return (
        <div className="mt-3 text-center">
           <ReactTooltip />
          <p>If nothing is triggering the dizziness, that means it's most likely a type of
            {/* eslint-disable-next-line */}
            <a className="link" data-tip="A condition of the inner ear that causes episodes of dizziness lasting minutes-hours without one specific trigger."> Spontaneous Episodic Vestibular Syndrome (s-EVS).</a>
          </p>
         
          <p>At this point, we can narrow it down to two main conditions, which are distinguished by the presence of any hearing-related symptoms. </p>
          <p>Is there any hearing loss or ringing in one ear?</p>
          <div className="text-center mt-5">
            <button className="btn btn-danger m-2 w-20"  onClick={onClick.bind(this,13,true)}>Yes</button>
            <button className="btn btn-danger m-2 w-20"  onClick={onClick.bind(this,14,true)}>No</button>
          </div>
         
         
        </div>

    )
  }
}
